// extracted by mini-css-extract-plugin
module.exports = {"className":"scrollbar_className__fxxhh"};